import { render, staticRenderFns } from "./MkButton.vue?vue&type=template&id=4c2e6ec2&scoped=true"
import script from "./MkButton.vue?vue&type=script&lang=js"
export * from "./MkButton.vue?vue&type=script&lang=js"
import style0 from "./MkButton.vue?vue&type=style&index=0&id=4c2e6ec2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2e6ec2",
  null
  
)

export default component.exports